:host {
  display: block;
}
:host([leading-line]) ::slotted(aha-history-list-item:first-of-type) {
  --aha-history-list-item--top: var(--spacer-10);
}
:host([trailing-line]) ::slotted(aha-history-list-item:last-of-type) {
  --aha-history-list-item--bottom: var(--spacer-10);
  --aha-history-list-item--bullet-line-visibility: visible;
}
